/* ------------------Approve QA Toaster Component -----------------
This component is the Toaster that appears when a QA reviewer accepts a submission.
*/
// ----------------- React Components -----------------
import React, { useState } from 'react';

// ----------------- Icons -----------------
import { FaSpinner } from 'react-icons/fa';
import { SiTicktick } from 'react-icons/si';

const ApproveQAToasterComponent = ({ onClose, onSubmit, documentId }) => {
    const [reason, setReason] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        setIsSubmitting(true);
        setErrorMessage('');
        setSuccessMessage('');
        
        try {
            // Call the parent's onSubmit function, passing the reason and document ID
            await onSubmit(reason || 'Approved - No additional comments', documentId);
            setSuccessMessage('QA Review Successfully Approved');
            
            // Add a delay before closing the toaster to allow the user to see the success message
            setTimeout(() => {
                onClose();
            }, 2000);
        } catch (error) {
            console.error('Error in handleSubmit:', error);
            setErrorMessage(error.message || 'Failed to approve submission');
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        if (!isSubmitting) {
            onClose();
        }
    };

    return (
        <div className='checklist-question-user-fill-in-checklist-main-container'>
            <div className="qa-reject-main-container">
                <div className="template-fill-in-elements-container">
                    <div className="user-fill-in-back-button-time-container">
                        {/* QA Header */}
                        <div className='user-fill-in-back-button-container'>
                            <div>
                                <h3>Compliance Tracker QA - <span className="secondary-color-paragraph">Approval</span></h3>
                                <i>This component is the final step to approving a consultant submission</i>
                            </div>
                        </div>
                    </div>

                    {/* Body */}
                    <div>
                        <div>
                            <div className="compliance-tracker-qa-approve-toaster-tick-text-main-main--container">
                                <div>
                                    <h3>Are you sure that you want to approve QA review for this template?</h3>
                                </div>
                            </div>

                            <div className="compliance-tracker-qa-approve-toaster-tick-main-main-icon-container">
                                <div className="compliance-tracker-qa-approve-toaster-tick-icon-main-container">
                                    <SiTicktick className="compliance-tracker-qa-approve-toaster-tick-main-login-tick-icon" />
                                </div>
                            </div>

                            
                            <div className="compliance-tracker-qa-approve-toaster-tick-button-p-main-main-container">
                                <p>By clicking 'Approve,' you acknowledge that you have reviewed and approve the consultant's submission.</p> 
                            </div>

                            {/* Error and Success Messages */}
                            {errorMessage && (
                                <div className='error-text'>
                                    <p>{errorMessage}</p>
                                </div>
                            )}

                            {successMessage && (
                                <div className="compliance-qa-approve-review-submission-success-message-container">
                                    <p>{successMessage}</p>
                                </div>
                            )}

                            {/* Button Container */}
                            <div className='checklist-question-toaster-button-cancel-container'>
                                <button 
                                    onClick={handleSubmit} 
                                    className='confirm-button'
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <FaSpinner className="fa-spin" />
                                            <span className="submitting-questions-text"> Processing...</span>
                                        </>
                                    ) : (
                                        'Approve'
                                    )}
                                </button>
                                        
                                <button 
                                    onClick={handleCancel} 
                                    type='button' 
                                    className='cancel-button'
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApproveQAToasterComponent;